import { render, staticRenderFns } from "./DischargeReport.vue?vue&type=template&id=6e9c08db"
import script from "./DischargeReport.vue?vue&type=script&lang=js"
export * from "./DischargeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports